import { Box, Flex } from "@chakra-ui/react";
import { useRef, useState } from "react";

import { Profile } from "../profile";
import { AnyUser } from "../types/any-user";

const GAP = 1;
const GAP_PX = 1 * 4;

export function ProfileList({ users, boxSize = 11 }: { users?: AnyUser[]; boxSize?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [maxAmount, setMaxAmount] = useState(999999999);

  setTimeout(() => {
    const div = ref.current;

    if (div && div.clientHeight && div.clientWidth) {
      const childHeight = boxSize * 4 + GAP_PX;
      const childWidth = boxSize * 4 + GAP_PX;
      // We add GAP_PX to the div size once to compensate for the last child in the row or column not needing the extra padding
      const newMaxAmount =
        Math.floor((div.clientHeight + GAP_PX) / childHeight) *
        Math.floor((div.clientWidth + GAP_PX) / childWidth);

      if (newMaxAmount !== maxAmount) setMaxAmount(newMaxAmount);
    }
  });

  return (
    <Box ref={ref} flexShrink={0} w="full" h="full" overflow="hidden">
      <Flex gap={GAP} flexWrap="wrap">
        {users?.map((user, index) => {
          if (index >= maxAmount) return null;

          if (index + 1 === maxAmount && index + 1 !== users.length)
            return (
              <Flex
                boxSize={boxSize}
                textStyle="lg"
                alignItems="center"
                justifyContent="center"
                key={user.email + user.id}
              >
                +{users.filter((_, innerIndex) => index <= innerIndex).length}
              </Flex>
            );

          return <Profile boxSize={boxSize} key={user.email + user.id} user={user} />;
        })}
      </Flex>
    </Box>
  );
}
